// Modules
import * as H from 'history'

export const getQueryParamsValue = (location: H.Location, nameParams: string): string | null => {
    const queryParams = new URLSearchParams(location.search)
    return queryParams.get(nameParams)
}

export const removeQueryParams = (location: H.Location, namesParams: string[], history: H.History<unknown>) => {
    const queryParams = new URLSearchParams(location.search)
    namesParams.forEach(nameParams => {
        if (queryParams.has(nameParams)) {
            queryParams.delete(nameParams)
        }
    })
    history.replace({
        search: queryParams.toString(),
    })
}

export const formattedUrl = (location: H.Location, nameParams: string, url: string): string => {
    const queryParams = getQueryParamsValue(location, nameParams)
    if (queryParams) {
        return `${url}?${nameParams}=${queryParams}`
    }
    return url
}

export const removeQueryParam = (location: H.Location, param: string): string => {
    const urlParams = new URLSearchParams(location.search)
    urlParams.delete(param)
    return urlParams.toString() ? `?${urlParams.toString()}` : ''
}
